var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCreditCardPrimaryLightOutlined = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0V0z",
    id: "cg9p9d6m6a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#cg9p9d6m6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(2 4.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.088 0c.965 0 1.736.74 1.736 1.643v.791c0 .081-.075.142-.16.142H.15c-.086 0-.15-.06-.15-.142v-.791C0 .73.782 0 1.736 0zm-.27.266H2.108C1.205.266.463.833.463 1.542v.614c0 .063.061.11.142.11h14.706c.081 0 .152-.047.152-.11v-.614c0-.701-.731-1.276-1.645-1.276zM15.674 3.681c.086 0 .15.063.15.146V8.98c0 .94-.782 1.693-1.734 1.693H1.734C.771 10.672 0 9.909 0 8.979V3.827c0-.083.064-.156.15-.146zm-.353.436H.605a.126.126 0 0 0-.142.125v4.421c0 .798.73 1.453 1.644 1.453H13.82c.903 0 1.644-.646 1.644-1.453v-4.42c0-.072-.06-.126-.142-.126z",
    fill: "#8CBAC7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#8CBAC7",
    strokeWidth: 0.3,
    x: 2.113,
    y: 6.566,
    width: 1.7,
    height: 1.7,
    rx: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCreditCardPrimaryLightOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-credit-card-primary-light-outlined.7f7b50d38b84d8e8f1435fcbc4dcf39c.svg";